// TODO: https://lucidlink.atlassian.net/browse/LUCID-22599
// Try to extract these functions as they're exact duplicates of the ones from file download
// it might not be possible as TS is a bit finicky for some reason
export const postMessageToMainOnBroadcastChannel = (channel, message) => {
    channel.postMessage(message);
};
export const postMessageToSwOnBroadcastChannel = (channel, message) => {
    channel.postMessage(message);
};
